import React from 'react';

type TimelinePlayheadProps = {
  outputTimeSec: number;
  positionPx: number;
  topOffsetPx?: number;
  heightPx?: number;
  onMouseDown?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const TimelinePlayhead: React.FC<TimelinePlayheadProps> = ({
  outputTimeSec: _outputTimeSec,
  positionPx,
  topOffsetPx = 0,
  heightPx = 64,
  onMouseDown,
}) => {
  return (
    <div
      className="pointer-events-none absolute z-20"
      style={{
        left: `${positionPx}px`,
        top: `${topOffsetPx}px`,
        height: `${heightPx}px`,
      }}
      data-testid="timeline-playhead"
    >
      {/* Tail: w-0.5 = 2px. -translate-x-1/2 shifts it left by 1px so its
          center aligns with the triangle tip at x=0 of the container. */}
      <div className="absolute inset-y-0 left-0 w-0.5 -translate-x-1/2 bg-white/90" />
      <div className="absolute top-0 -left-[5px] h-0 w-0 border-l-[5px] border-r-[5px] border-t-[6px] border-l-transparent border-r-transparent border-t-white" />
      {onMouseDown ? (
        <button
          type="button"
          className="pointer-events-auto absolute inset-y-0 -left-2 w-4 cursor-ew-resize bg-transparent"
          onMouseDown={onMouseDown}
          aria-hidden
          tabIndex={-1}
          data-testid="timeline-playhead-drag-handle"
        />
      ) : null}
    </div>
  );
};
